import Link from 'next/link';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { ISubCollectionList } from 'shared/types/ConsumerSearch';
import { SearchFilterPillStyle } from 'search/styles/SearchStyles';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';

const SearchFilterSubCollectionMobile = ({
  subCollections,
}: {
  subCollections: ISubCollectionList;
}) => {
  const { pathname, query } = useRouter();

  const currentSubCollection = query.slug[1] || '';

  if (!subCollections || subCollections.length === 0) return null;

  return (
    <>
      {subCollections.map((subCollection) => {
        const isSelected = currentSubCollection === subCollection.collectionSlug;

        const slug = isSelected ? [query.slug[0]] : [query.slug[0], subCollection.collectionSlug];

        const href = {
          pathname,
          query: {
            ...query,
            slug,
          },
        };

        const handleOnClick = () => {
          sendTrackingEvent('FILTER_APPLY_TAP', {
            event_context: 'collection',
            filter_name: subCollection.name,
            filter_selection: isSelected,
            collection_slug: subCollection.collectionSlug,
          });
        };

        return (
          <SearchFilterSubCollectionMobile.Link
            data-qa={`sub_collection_item_${subCollection.collectionSlug}`}
            key={subCollection.collectionSlug}
            $isSelected={isSelected}
            className={isSelected ? 'selected' : ''}
            onClick={handleOnClick}
          >
            <Link href={href} prefetch={false} shallow scroll legacyBehavior>
              {subCollection.name}
            </Link>
          </SearchFilterSubCollectionMobile.Link>
        );
      })}
    </>
  );
};

SearchFilterSubCollectionMobile.Link = styled.div<{ $isSelected: boolean }>`
  ${SearchFilterPillStyle}

  text-transform: capitalize;
  background-color: ${({ theme }) => theme.navigation.backgroundColor};
  border: ${({ theme }) => theme.borders.black};
  color: ${({ theme }) => theme.navigation.textColor};

  &.selected {
    color: ${({ theme }) => theme.navigation.backgroundColor};
    background-color: ${({ theme }) => theme.navigation.loaderColor};
  }

  &:active {
    border: ${({ theme }) => theme.borders.black};
  }

  &:hover {
    text-decoration: none;
  }
`;

export default SearchFilterSubCollectionMobile;
